import {
  MANATEE_GREY,
  GRECIAN_GREY,
  CORNFLOWER_BLUE,
  HALF_COLONIAL_WHITE,
  HINT_GREEN,
  INFO_BLUE,
  MATISSE_BLUE,
  ROYAL_BLUE_VIVID,
  SEA_GREEN,
  ZEST_ORANGE
} from "../../../constants/colors";
import {
  FONT_SIZE,
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD
} from "../../../constants/style_constants";
import { fallbackValues as textTheme } from "../text/Text.theme";

const background = {
  info: `${INFO_BLUE}`,
  warn: `${HALF_COLONIAL_WHITE}`,
  primary: `${CORNFLOWER_BLUE}`,
  primaryHeadline: `${CORNFLOWER_BLUE}`,
  secondary: `${ROYAL_BLUE_VIVID}`,
  secondaryHeadline: `${ROYAL_BLUE_VIVID}`,
  success: `${HINT_GREEN}`,
  disabled: `${GRECIAN_GREY}`
};

const color = {
  info: `${MATISSE_BLUE}`,
  warn: `${ZEST_ORANGE}`,
  primary: `${ROYAL_BLUE_VIVID}`,
  primaryHeadline: `${ROYAL_BLUE_VIVID}`,
  secondary: `${CORNFLOWER_BLUE}`,
  secondaryHeadline: `${CORNFLOWER_BLUE}`,
  success: `${SEA_GREEN}`,
  disabled: `${MANATEE_GREY}`
};

const fontWeight = {
  info: FONT_WEIGHT_REGULAR,
  warn: FONT_WEIGHT_REGULAR,
  primary: FONT_WEIGHT_REGULAR,
  primaryHeadline: FONT_WEIGHT_SEMIBOLD,
  secondary: FONT_WEIGHT_REGULAR,
  secondaryHeadline: FONT_WEIGHT_SEMIBOLD,
  success: FONT_WEIGHT_REGULAR,
  disabled: FONT_WEIGHT_REGULAR
};

const fontSizeMobile = {
  info: textTheme.fontSize.pXXS,
  warn: textTheme.fontSize.pXXS,
  primary: textTheme.fontSize.pXXS,
  primaryHeadline: textTheme.fontSize.pXS,
  secondary: textTheme.fontSize.pXXS,
  secondaryHeadline: textTheme.fontSize.pXS,
  success: textTheme.fontSize.pXXS,
  disabled: textTheme.fontSize.pXXS
};

const fontSizeDesktop = {
  info: textTheme.fontSize.pXS,
  warn: textTheme.fontSize.pXS,
  primary: textTheme.fontSize.pXS,
  primaryHeadline: textTheme.fontSize.pS,
  secondary: textTheme.fontSize.pXS,
  secondaryHeadline: textTheme.fontSize.pS,
  success: textTheme.fontSize.pXS,
  disabled: textTheme.fontSize.pXS
};

export const fallbackValues = {
  background,
  color,
  fontWeight,
  fontSizeMobile,
  fontSizeDesktop
};
